import React from "react";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { AppContext } from "@lib/types/Context";
import { SharedManagers } from "@app/shared";

const PaymentProviderManagers: React.FC = () => {
  const { providerId } = useParams();
  const { messages } = useIntl();

  // Check if user has permission to view wallet pool
  // if (!permissions.canViewWalletPool) {
  //   return <NoPermission />;
  // }

  return (
    <SharedManagers
      context={AppContext.PAYMENT_PROVIDER}
      providerId={providerId}
      customTitle={
        messages["sidebar.paymentProviderTransactions.systemUsers"] as string
      }
      // customBreadcrumb={{
      //   items: [
      //     { key: AppContext.PAYMENT_PROVIDER },
      //     { title: provider?.name },
      //     {
      //       title: messages[
      //         "sidebar.paymentProviderTransactions.systemUsers"
      //       ] as string,
      //     },
      //   ],
      // }}
    />
  );
};

export default PaymentProviderManagers;
